import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import resourcesToBackend from 'i18next-resources-to-backend';
import readConfig from './utils/readClientConfiguration';
import appConfiguration from './config/default.json';

// Pobierz kod kraju z konfiguracji
let countryCode = readConfig(appConfiguration, 'countrySymbol') || 'hr';

// Inicjalizacja i18n z dynamicznym ładowaniem plików
i18n
    .use(resourcesToBackend((language, namespace) => {
        // Zwracaj obietnicę importu dynamicznego
        return import(`./locales/${language}/translations.json`)
            .catch(error => {
                console.error(`Failed to load translations for ${language}:`, error);
                // Fallback do HR jeśli brakuje tłumaczeń
                if (language !== 'hr') {
                    return import(`./locales/hr/translations.json`);
                }
                // Jeśli nawet fallback nie działa, zwróć pusty obiekt
                return Promise.resolve({ default: {} });
            });
    }))
    .use(initReactI18next) // integracja z Reactem
    .init({
        lng: countryCode, // język z konfiguracji
        fallbackLng: 'hr', // język awaryjny
        debug: process.env.NODE_ENV === 'development',
        interpolation: {
            escapeValue: false, // nie uciekaj od HTML
        },
        ns: ['translations'], // przestrzenie nazw, aby pasować do struktur plików
        defaultNS: 'translations',
        react: {
            useSuspense: false // wyłącz Suspense dla SSR
        }
    });

export default i18n;